import { css } from "@styled-system/css";

export const headerWrapperClass = css({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	marginBottom: "4",
});
